import { render, staticRenderFns } from "./shopsManage.vue?vue&type=template&id=f04ba67e&scoped=true"
import script from "./shopsManage.vue?vue&type=script&lang=js"
export * from "./shopsManage.vue?vue&type=script&lang=js"
import style0 from "./shopsManage.vue?vue&type=style&index=0&id=f04ba67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04ba67e",
  null
  
)

export default component.exports